export const getRefundMethodsOptions = (refundMethods, selectedRefundMethod) => {
  return refundMethods?.map(method => ({
    enabled: true,
    name: method.name,
    selected: method.name === selectedRefundMethod,
  }))
}
